"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SampleStatus = void 0;
var SampleStatus;
(function (SampleStatus) {
    SampleStatus[SampleStatus["New"] = 0] = "New";
    SampleStatus[SampleStatus["AtLab"] = 1] = "AtLab";
    SampleStatus[SampleStatus["Exceedance"] = 2] = "Exceedance";
    SampleStatus[SampleStatus["InMailStream"] = 3] = "InMailStream";
    SampleStatus[SampleStatus["Undeliverable"] = 4] = "Undeliverable";
    SampleStatus[SampleStatus["Requested"] = 5] = "Requested";
    SampleStatus[SampleStatus["Cancelled"] = 6] = "Cancelled";
    SampleStatus[SampleStatus["Collected"] = 7] = "Collected";
    SampleStatus[SampleStatus["Shipped"] = 8] = "Shipped";
    SampleStatus[SampleStatus["Invalid"] = 9] = "Invalid";
})(SampleStatus = exports.SampleStatus || (exports.SampleStatus = {}));
//# sourceMappingURL=SampleStatus.js.map